export default "__VITE_ASSET__CYJ2Xt0b__"